import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGridSection() {
  const featuredCategories = categories.slice(0, 6);

  const categoryImages = [
    'https://readdy.ai/api/search-image?query=Soft%20romantic%20illustration%20with%20floating%20pink%20hearts%20and%20flowers%20delicate%20pastel%20color%20palette%20gentle%20atmosphere%20Korean%20manhwa%20art%20style%20clean%20cream%20background&width=700&height=500&seq=cat-romance&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Magical%20fantasy%20illustration%20with%20floating%20crystals%20and%20mystical%20light%20orbs%20ethereal%20atmosphere%20soft%20lavender%20and%20gold%20tones%20Korean%20webtoon%20aesthetic%20clean%20background&width=700&height=500&seq=cat-fantasy&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Dynamic%20action%20illustration%20with%20flame%20and%20energy%20effects%20dramatic%20warm%20orange%20and%20red%20color%20scheme%20powerful%20atmosphere%20Korean%20manhwa%20style%20clean%20dark%20gradient%20background&width=700&height=500&seq=cat-action&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Modern%20cityscape%20illustration%20at%20sunset%20with%20warm%20golden%20lighting%20clean%20minimal%20architectural%20lines%20sophisticated%20urban%20atmosphere%20Korean%20aesthetic%20soft%20gradients&width=700&height=500&seq=cat-drama&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Bright%20playful%20illustration%20with%20colorful%20confetti%20and%20fun%20elements%20cheerful%20vibrant%20color%20palette%20happy%20atmosphere%20Korean%20webtoon%20comedy%20style%20clean%20light%20background&width=700&height=500&seq=cat-comedy&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Mysterious%20atmospheric%20illustration%20with%20fog%20and%20moonlight%20dark%20silhouettes%20eerie%20cool%20tones%20suspenseful%20mood%20Korean%20thriller%20webtoon%20aesthetic%20clean%20dark%20gradient%20background&width=700&height=500&seq=cat-thriller&orientation=landscape',
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-sm font-semibold text-foreground-400 uppercase tracking-wide mb-2">
              分类浏览
            </p>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              探索你感兴趣的
              <span className="italic text-primary-500 font-serif"> 漫画类型</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            涵盖恋爱、奇幻、动作、悬疑等十余种类型，每一类都有海量精选韩漫等你发现
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredCategories.map((cat, i) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group cursor-pointer rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              {/* Image */}
              <div className="aspect-[7/5] overflow-hidden rounded-t-2xl">
                <img
                  src={categoryImages[i]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium mb-3">
                  {cat.name}
                </span>
                <h3 className="text-lg font-bold text-foreground-950 font-heading group-hover:text-primary-500 transition-colors">
                  {cat.count}+ 部作品
                </h3>
                <div className="flex items-center gap-2 mt-3 text-sm text-foreground-500">
                  <span>浏览全部</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}